import React from 'react';
import { Typography } from 'antd';

function TextDescription({ children }) {
    return <Typography className="paragraph justify-text">{children}</Typography>;
}

export default TextDescription;
